import { render, staticRenderFns } from "./product-included-services-link.vue?vue&type=template&id=2f1893fd&"
import script from "./product-included-services-link.vue?vue&type=script&lang=js&"
export * from "./product-included-services-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports